/**
 * Toast Notification Component
 *
 * Shows temporary notification messages
 * Auto-dismisses after 3 seconds
 */

import { useEffect } from 'react'
import './Toast.css'

function Toast({ message, type = 'success', onClose }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose()
    }, 3000)

    return () => clearTimeout(timer)
  }, [onClose])

  return (
    <div className={`toast toast-${type}`}>
      <div className="toast-icon">
        {type === 'success' && '✓'}
        {type === 'info' && 'ℹ️'}
        {type === 'warning' && '⚠️'}
        {type === 'error' && '✕'}
      </div>
      <div className="toast-message">{message}</div>
      <button className="toast-close" onClick={onClose}>×</button>
    </div>
  )
}

export default Toast
